import { Store } from "@ngxs/store";
import { SessionState } from "@state/session/session.state";

import {
  type HttpHandlerFn,
  type HttpInterceptorFn,
  type HttpRequest,
} from "@angular/common/http";
import { inject } from "@angular/core";

export const authenticationInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const store = inject(Store);
  const token = store.selectSnapshot(SessionState.ssoToken);

  if (!token || req.url.includes("/sso/auth/")) {
    return next(req);
  }

  const modifiedReq = req.clone({
    headers: req.headers.set("Authorization", `Bearer ${token}`),
  });

  return next(modifiedReq);
};
